export class PresenceMonitoringData {
  public employeeList: PresenceMonitoringEmployee[];
  public settings: PresenceMonitoringSettings;
}

export class PresenceMonitoringSettings {
  public departmentId: string[];
  public attendanceFilePath: string;
  public columns: number;
  public reloadTime: number;
  public autoSlide: boolean;
  public autoSlideDuration: number;
}

export class PresenceMonitoringEmployee {
  public personId: number;
  public myRotaGuid: string | null;
  public name: string;
  public photoPath: string | null;
  public dutyTimes: Date[] | null;
  public bookings: Date[] | null;
  public bookingFlag: number;
  public bookingColour: string;
  public departmentId: number;
  public departmentName: string;
  public additionalText: string | null;
  public position: string | null;
}

export enum BookingFlag {
  'Status_Correct_booking' = 1,
  'Status_Booking_missing',
  'Status_Not_present_or_scheduled',
  'Status_Unscheduled',
  'Status_Arrived_early',
  'Status_Arrived_late',
  'Status_Left_early',
  'Status_Left_late',
  'Status_Break',
  'Status_Absent_with_reason',
}
